import { Logger } from '~/helpers/logger';
import { CartResultUnconfirmedError } from '~/modules/checkout/composables/useCart/cartCoordinator';
import { Cart, Maybe, SetBillingAddressOnCartInput } from '~/modules/GraphQL/types';

export const saveBillingAddressCommand = {
  execute: async (context, cartId, billingDetails, customQuery, customHeaders): Promise<Maybe<Cart>> => {
    const {
      apartment,
      neighborhood,
      extra,
      sameAsShipping,
      customerAddressId,
      ...address
    } = billingDetails;

    if (address && (address.region_name || address.region_name === '')) {
      delete address.region_name;
    }

    let billingData;
    if (sameAsShipping) {
      billingData = { same_as_shipping: true };
    } else if (customerAddressId !== null && customerAddressId !== undefined) {
      const id = Number(customerAddressId);
      if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Invalid customer address');
      billingData = { customer_address_id: id };
    } else {
      billingData = {
        address: {
          ...address,
          street: [address.street, apartment, neighborhood, extra].filter(Boolean),
        },
        same_as_shipping: sameAsShipping,
      };
    }

    const setBillingAddressOnCartInput: SetBillingAddressOnCartInput = {
      cart_id: cartId,
      billing_address: billingData,
    };

    const { data, errors } = await context.$vsf.$magento.api.setBillingAddressOnCart(
      setBillingAddressOnCartInput,
      customQuery,
      customHeaders,
    );

    Logger.debug('[setBillingAddressOnCart Result]:', { data, errors });
    const cart = data?.setBillingAddressOnCart?.cart;
    if (errors?.length) {
      if (cart) throw new CartResultUnconfirmedError(errors[0]?.message);
      throw new Error(errors[0]?.message || 'Error with set billing address');
    }
    if (!cart?.billing_address || cart.id !== cartId || !cart.prices || !Array.isArray(cart.shipping_addresses)
      || !Array.isArray(cart.available_payment_methods)) {
      throw new CartResultUnconfirmedError('Unable to confirm billing checkout state.');
    }
    return cart;
  },
};
